export default "__VITE_ASSET__C7oty0Og__"